import {
  GET_BRANCHES,
  GET_BRANCHES_SUCCESS,
  GET_BRANCHES_FAIL,
  CREATE_BRANCH,
  CREATE_BRANCH_SUCCESS,
  CREATE_BRANCH_FAIL,
  UPDATE_BRANCH,
  UPDATE_BRANCH_SUCCESS,
  UPDATE_BRANCH_FAIL,
  DELETE_BRANCH,
  DELETE_BRANCH_SUCCESS,
  DELETE_BRANCH_FAIL,
  SELECT_BRANCH,
} from "./actionTypes"

const INIT_STATE = {
  branches: {
    branches: [],
    total: "",
    page: "",
  },
  branchDetails: {},
  error: {},
  loading: false,
  selectedBranch: null,
}

const Branches = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SELECT_BRANCH:
      return {
        ...state,
        selectedBranch: action.payload,
      }
    // Branch - This line cannot be edited or removed
    case GET_BRANCHES:
    case CREATE_BRANCH:
    case UPDATE_BRANCH:
    case DELETE_BRANCH:
      return {
        ...state,
        loading: true,
      }

    case DELETE_BRANCH_FAIL:
    case GET_BRANCHES_FAIL:
    case UPDATE_BRANCH_FAIL:
    case CREATE_BRANCH_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case GET_BRANCHES_SUCCESS:
      return {
        ...state,
        branches: action.payload,
        error: {},
        loading: false,
      }

    case CREATE_BRANCH_SUCCESS:
      return {
        ...state,
        branches: {
          ...state.branches,
          branches: [
            action.payload?.createbranchData,
            ...state.branches.branches,
          ],
          total: state.branches.total + 1,
        },
        branchDetails: action.payload,
        error: {},
        loading: false,
      }

    case UPDATE_BRANCH_SUCCESS:
      return {
        ...state,
        branches: {
          ...state.branches,
          branches: state.branches.branches.map(branch =>
            branch._id === action.payload._id
              ? { ...branch, ...action.payload }
              : branch
          ),
        },
        branchDetails: action.payload,
        loading: false,
        error: {},
      }

    case DELETE_BRANCH_SUCCESS:
      return {
        ...state,
        branches: {
          ...state.branches,
          branches: state.branches.branches.filter(
            branch => branch._id !== action.payload._id
          ),
        },
        error: {},
        loading: false,
      }

    default:
      return state
  }
}

export default Branches
